import React from 'react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import UserManagement from 'components/UserManagement';
import ProtectedRoute from 'components/ProtectedRoute';

export default function UserManagementView() {
  return (
    <AdminPageShell title="Usuarios">
      <ProtectedRoute requiredPermissions={['users.view']}>
        <UserManagement />
      </ProtectedRoute>
    </AdminPageShell>
  );
}
